import MyScheduleComponent from './mySchedule/mySchedule.component';
import * as myScheduleActions from './mySchedule/mySchedule.actions';
import { myScheduleReducer } from './mySchedule/mySchedule.reducer';
import AppointmentDetailsComponent from './appointmentDetails/appointmentDetails.component';
import * as appointmentDetailsActions from './appointmentDetails/appointmentDetails.actions';
import { appointmentDetailsReducer } from './appointmentDetails/appointmentDetails.reducer';

export {
  MyScheduleComponent,
  myScheduleActions,
  myScheduleReducer,
  AppointmentDetailsComponent,
  appointmentDetailsActions,
  appointmentDetailsReducer,
}


// WEBPACK FOOTER //
// src/scheduler/index.js